type SiteChromeProps = {
	activePage: "home" | "animals";
};

/**
 * Render the small badge and floating route switcher from the static reference.
 */
export const SiteChrome = ({ activePage }: SiteChromeProps) => {
	return (
		<>
			<a className="logo-badge" href="/" title="AvatarAnimals home">
				<img
					src="https://images.avataranimals.com/public/logo.png"
					alt="AvatarAnimals"
				/>
			</a>

			<nav className="mini-nav" aria-label="Primary navigation">
				<a
					className={`mini-link ${activePage === "home" ? "active" : ""}`}
					href="/"
					aria-current={activePage === "home" ? "page" : undefined}
				>
					Home
				</a>
				<a
					className={`mini-link ${activePage === "animals" ? "active" : ""}`}
					href="/animals"
					aria-current={activePage === "animals" ? "page" : undefined}
				>
					Animals
				</a>
			</nav>
		</>
	);
};
